import React from "react";
import OrderContainer from "../containers/OrderContainer";

const Order = () => {
    return (
        <div>
            <OrderContainer />
        </div>
    );
};

export default Order;
